import { defaultHttpClient } from 'shared/src/api/httpClient';
import type {
  GetFolderDetailMetaParams,
  GetFolderDetailMetaResponse,
} from './types';

export const getFolderDetailMeta = async ({
  folder_sno,
}: GetFolderDetailMetaParams) => {
  return defaultHttpClient
    .request<GetFolderDetailMetaResponse>({
      method: 'GET',
      url: `/api/v2/members/me/liked_folders/${folder_sno}/meta/`,
    })
    .then(result => result.data);
};
